"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectPromiseAction = exports.resolvePromiseAction = exports.promiseMiddleware = exports.createPromiseAction = void 0;
//Utils
const lodash_1 = __importDefault(require("lodash"));
const typesafe_actions_1 = require("typesafe-actions");
function createPromiseAction(requestArg, successArg, failureArg) {
    return function () {
        const request = typesafe_actions_1.createCustomAction(requestArg, (...payload) => ({
            payload: payload[0],
            meta: {
                promiseAction: true,
                promise: {},
            },
        }));
        const success = typesafe_actions_1.createAction(successArg)();
        const failure = typesafe_actions_1.createAction(failureArg)();
        return {
            request,
            success,
            failure,
        };
    };
}
exports.createPromiseAction = createPromiseAction;
exports.promiseMiddleware = () => (next) => (action) => {
    var _a;
    if (!((_a = action.meta) === null || _a === void 0 ? void 0 : _a.promiseAction)) {
        next(action);
        return new Promise(() => { });
    }
    return new Promise((resolve, reject) => {
        next(lodash_1.default.merge(action, {
            meta: {
                promise: {
                    resolve,
                    reject,
                },
            },
        }));
    });
};
function resolvePromiseAction(action, payload) {
    var _a, _b, _c;
    (_c = (_b = (_a = action.meta) === null || _a === void 0 ? void 0 : _a.promise) === null || _b === void 0 ? void 0 : _b.resolve) === null || _c === void 0 ? void 0 : _c.call(_b, payload);
}
exports.resolvePromiseAction = resolvePromiseAction;
function rejectPromiseAction(action, payload) {
    var _a, _b, _c;
    (_c = (_b = (_a = action.meta) === null || _a === void 0 ? void 0 : _a.promise) === null || _b === void 0 ? void 0 : _b.reject) === null || _c === void 0 ? void 0 : _c.call(_b, payload);
}
exports.rejectPromiseAction = rejectPromiseAction;
//# sourceMappingURL=index.js.map